export const RESOURCE_HUB_CONSTANTS = {
  BUG_REPORT_SIM_LINK:
    'https://t.corp.amazon.com/create/templates/60c12710-7f4c-4c78-ae28-36ec2ad1c473',
  NEW_FEATURE_SIM_LINK:
    'https://issues.amazon.com/issues/create?template=ae4818c2-3eba-43ba-b27e-9e96e316662e',
};
